import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { uiReducer } from './ui.reducer';
import { UiFacade } from './ui.facade';

/**
 * UI State Module
 * 
 * Registers the UI feature store and provides the facade.
 */
@NgModule({
  imports: [
    StoreModule.forFeature('ui', uiReducer)
  ],
  providers: [
    UiFacade
  ]
})
export class UiStateModule {}
